import { render, staticRenderFns } from "./RenderWorkflow.vue?vue&type=template&id=52d2b9e7&scoped=true&"
import script from "./RenderWorkflow.vue?vue&type=script&lang=js&"
export * from "./RenderWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./RenderWorkflow.vue?vue&type=style&index=0&id=52d2b9e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2b9e7",
  null
  
)

export default component.exports